import { FC } from 'react';

type Props = {
	className?: string;
};

const DragDropVerticalIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M6.6665 5H6.6718M6.6665 10H6.6718M6.6665 15H6.6718M13.3279 5H13.3332M13.3279 10H13.3332M13.3279 15H13.3332'
				stroke='inherit'
				strokeWidth='2.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default DragDropVerticalIcon;
